export const ICON_SIZE = { width: '118', height: '24' };
//# sourceMappingURL=iconSize.js.map